<template>
    <div>
        <div class="row">
            <div class="col-md-6">
                <h3>
                    List of Forms
                </h3>
            </div>
            <div class="col-md-6">
                <input-search-icon v-model="query" @search="searchWebform" />
            </div>
        </div>
        <LoaderList v-if="isLoading" class="w-100" />
        <b-table-simple v-else borderless hover class="list">
            <thead>
                <tr>
                    <th style="min-width: 200px;">
                        <sorting
                            :order-by="
                                meta && meta.order == 'title'
                                    ? meta.orderBy
                                    : null
                            "
                            @sorting="
                                orderBy =>
                                    getList(meta.currentPage, orderBy, 'title')
                            "
                            text="Title:"
                        >
                        </sorting>
                    </th>
                    <th style="min-width: 200px;">
                        <sorting
                            :order-by="
                                meta && meta.order == metaOrderModule
                                    ? meta.orderBy
                                    : null
                            "
                            @sorting="
                                orderBy =>
                                    getList(
                                        meta.currentPage,
                                        orderBy,
                                        metaOrderModule
                                    )
                            "
                            :text="isClientModule ? 'Patient:' : 'Client:'"
                        >
                        </sorting>
                    </th>
                    <th class="text-nowrap">
                        <sorting
                            :order-by="
                                meta && meta.order == 'sent_date'
                                    ? meta.orderBy
                                    : null
                            "
                            @sorting="
                                orderBy =>
                                    getList(
                                        meta.currentPage,
                                        orderBy,
                                        'sent_date'
                                    )
                            "
                            text="Sent:"
                        >
                        </sorting>
                    </th>
                    <th class="text-nowrap">
                        <sorting
                            :order-by="
                                meta && meta.order == 'submitted_at'
                                    ? meta.orderBy
                                    : null
                            "
                            @sorting="
                                orderBy =>
                                    getList(
                                        meta.currentPage,
                                        orderBy,
                                        'submitted_at'
                                    )
                            "
                            text="Submitted:"
                        >
                        </sorting>
                    </th>
                    <th class="text-nowrap">
                        <sorting
                            :order-by="
                                meta && meta.order == 'update_at'
                                    ? meta.orderBy
                                    : null
                            "
                            @sorting="
                                orderBy =>
                                    getList(
                                        meta.currentPage,
                                        orderBy,
                                        'update_at'
                                    )
                            "
                            text="Last Updated:"
                        >
                        </sorting>
                    </th>
                    <th class="text-nowrap" style="min-width: 150px;">
                        <sorting
                            :order-by="
                                meta && meta.order == 'create_by'
                                    ? meta.orderBy
                                    : null
                            "
                            @sorting="
                                orderBy =>
                                    getList(
                                        meta.currentPage,
                                        orderBy,
                                        'create_by'
                                    )
                            "
                            text="Created By:"
                        >
                        </sorting>
                    </th>
                    <th class=""></th>
                </tr>
            </thead>
            <tbody v-if="webforms.length == 0">
                <tr>
                    <td colspan="7"><i>No records available</i></td>
                </tr>
            </tbody>
            <tbody v-else>
                <tr v-for="(webform, i) in webforms" :key="i">
                    <td>
                        <WebformLink
                            v-if="webform"
                            :router-name="routerName"
                            :webform="webform"
                        />
                    </td>
                    <td>
                        <PatientName
                            v-if="isClientModule && webform.patient"
                            :patient="webform.patient"
                        />
                        <ClientName
                            v-else-if="
                                (isPatientModule || isSoapModule) &&
                                webform.client
                            "
                            :client="webform.client"
                        />
                    </td>
                    <td class="text-nowrap">
                        <span>
                            {{
                                webform.sent_date
                                    ? _carbonDateDisplay(webform.sent_date)
                                    : ""
                            }}
                        </span>
                    </td>
                    <td class="text-nowrap">
                        <span>
                            {{
                                webform.submitted_at
                                    ? _carbonDateDisplay(webform.submitted_at)
                                    : ""
                            }}
                        </span>
                    </td>
                    <td class="text-nowrap">
                        <span>
                            {{ _carbonDateDisplay(webform.update_at) }}
                        </span>
                    </td>
                    <td>
                        <span>
                            {{
                                webform.create_by ? webform.create_by.label : ""
                            }}
                        </span>
                    </td>
                    <td class="options">
                        <spinner v-if="webform.isLoading" />
                        <b-dropdown
                            v-else-if="
                                webform.isCanEdit ||
                                webform.isCanDelete ||
                                webform.isCanSend ||
                                webform.isCanPrint
                            "
                            size="sm"
                            variant="link"
                            right
                            no-caret
                        >
                            <template v-slot:button-content>
                                <i class="cus-cog-down"></i>
                            </template>
                            <b-dropdown-item
                                v-if="webform.isCanEdit"
                                :to="{
                                    name: isClientModule
                                        ? 'client_webform'
                                        : 'patient_webform',
                                    params: {
                                        id: webform.encoded_id
                                    }
                                }"
                            >
                                <i class="cus-page-white-edit"></i>
                                Edit Form
                            </b-dropdown-item>

                            <b-dropdown-item
                                v-if="
                                    webform.isCanSend &&
                                    (!checkExtensionsSMSEnabled ||
                                        (checkExtensionsSMSEnabled &&
                                            !webform.isClientHasMobile))
                                "
                                disabled
                                v-b-tooltip.hover="{
                                    placement: 'left',
                                    title: !checkExtensionsSMSEnabled
                                        ? CCLIENT.ALERT_MESSAGE
                                              .EXTENSION_SMS_DISABLED
                                        : CCLIENT.ALERT_MESSAGE.MOBILE_NOT_EXIST
                                }"
                            >
                                <i class="cus-phone disabled-icon"></i>
                                <span class="text-muted">Text (SMS) Form</span>
                            </b-dropdown-item>
                            <b-dropdown-item
                                v-else-if="
                                    webform.isCanSend &&
                                    checkExtensionsSMSEnabled &&
                                    webform.isClientHasMobile
                                "
                                @click="sendSMS(webform)"
                            >
                                <i class="cus-phone"></i>
                                Text (SMS) Form
                            </b-dropdown-item>

                            <b-dropdown-item
                                v-if="
                                    webform.isCanSend &&
                                    webform.isClientHasEmail
                                "
                                @click="sendEmail(webform)"
                            >
                                <i class="cus-email"></i> Email Form
                            </b-dropdown-item>
                            <b-dropdown-item
                                v-if="
                                    webform.isCanSend &&
                                    !webform.isClientHasEmail
                                "
                                disabled
                                v-b-tooltip.hover="{
                                    placement: 'left',
                                    title: CCLIENT.ALERT_MESSAGE.EMAIL_NOT_EXIST
                                }"
                            >
                                <i class="cus-email disabled-icon"></i>
                                <span class="text-muted">Email Form</span>
                            </b-dropdown-item>
                            <b-dropdown-item
                                v-if="webform.isCanPrint"
                                @click="printWebform(webform)"
                            >
                                <i class="cus-printer"></i> Print Form
                            </b-dropdown-item>
                            <b-dropdown-item
                                v-if="webform.isCanDelete"
                                @click="deleteWebform(webform)"
                            >
                                <i class="cus-delete"></i> Delete Form
                            </b-dropdown-item>
                        </b-dropdown>
                    </td>
                </tr>
            </tbody>
        </b-table-simple>

        <div class="text-right w-100 p-3" v-if="showPagination">
            <b-pagination
                v-show="meta.lastPage > 1"
                class="vet-pagination mt-0 mb-0"
                align="right"
                v-model="meta.currentPage"
                :total-rows="meta.total"
                :per-page="meta.perPage"
                prev-text="Prev"
                next-text="Next"
                first-text="Start"
                last-text="Last"
                @change="getList"
            />
        </div>
        <modal-delete-webform ref="modalDeleteWebform" @onsuccess="onSuccess" />
        <modal-SMS ref="modalSMS" module="client" @onsuccess="getList" />
        <modal-email ref="modalEmail" module="client" @onsuccess="getList" />
    </div>
</template>

<script>
import PatientDocumentService from "@/services/patient-documents";
import ClientDocumentService from "@/services/client-documents";
import ClientWebformService from "@/services/client-webform";
import { debounce, isEmpty } from "lodash";
import WebformMixin from "@/mixins/webform";
import CCLIENT from "@/constants/clients";
import DOCUMENTS from "@/constants/documents";

export default {
    mixins: [WebformMixin],
    components: {
        LoaderList: () => import("@/components/elements/loader-list.vue"),
        Sorting: () => import("@/module/commons/sorting.vue"),
        inputSearchIcon: () => import("@/module/commons/input-search-icon.vue"),
        WebformLink: () => import("@/components/commons/webform-link"),
        PatientName: () => import("@/components/commons/patient-name"),
        ModalDeleteWebform: () => import("@/components/webform/modal-delete"),
        ModalSMS: () => import("@/components/webform/modal-send-sms"),
        ModalEmail: () => import("@/components/webform/modal-send-email"),
        Spinner: () => import("@/components/elements/spinner"),
        ClientName: () => import("@/components/commons/client-name")
    },
    props: {
        module: {
            type: String,
            required: true,
            validator: function (value) {
                // The value must match one of these strings
                return ["client", "patient", "soap"].indexOf(value) !== -1;
            }
        },
        clientId: {
            type: String,
            default: null
        },
        soapId: {
            type: String,
            default: null
        },
        patientId: {
            type: String,
            default: null
        }
    },
    data() {
        return {
            CCLIENT,
            query: "",
            webforms: [],
            isLoading: false,
            meta: null,
            showPagination: false
        };
    },
    computed: {
        isClientModule() {
            return this.module === "client";
        },
        isPatientModule() {
            return this.module === "patient";
        },
        isSoapModule() {
            return this.module === "soap";
        },
        metaOrderModule() {
            return this.isClientModule ? "patient" : "client";
        },
        routerName() {
            return this.isClientModule ? "client_webform" : "patient_webform";
        },
        isSoap() {
            return this.$route.name === "soap";
        }
    },
    mounted() {
        this.getList(1);
    },
    methods: {
        async getList(page = 1, orderBy = "desc", order = "update_at") {
            this.isLoading = true;

            try {
                let params = {
                    page: page,
                    perPage: this.PER_PAGE,
                    orderBy: orderBy,
                    order: order,
                    query: this.query
                };
                let response = null;

                if (this.isClientModule) {
                    params.client_id = this.clientId;
                    response = await ClientDocumentService.getWebforms(params);
                } else if (this.isPatientModule || this.isSoapModule) {
                    params.patient_id = this.patientId;
                    if (this.isSoapModule) {
                        params.soap_id = this.soapId;
                    }
                    response = await PatientDocumentService.getWebforms(params);
                }

                if (response && response.meta) {
                    this.webforms = response.resource.map(webform => {
                        webform.isLoading = false;
                        webform.isCanDelete = this.checkCanDelete(webform);
                        webform.isCanEdit = this.checkCanEdit(webform);
                        webform.isCanSend = this.checkCanSend(webform);
                        webform.isCanPrint = this.checkCanPrint(webform);
                        webform.isClientHasMobile = !isEmpty(
                            webform.client.mobile
                        );
                        webform.isClientHasEmail = !isEmpty(
                            webform.client.email
                        );
                        return webform;
                    });

                    this.isLoading = false;

                    this.meta = response.meta;
                    this.meta.orderBy = orderBy;
                    this.meta.order = order;
                    this.showPagination = response.meta.lastPage > 1; // show pagination if there's more than 1 page
                } else {
                    throw "error";
                }
            } catch (error) {
                this._message("Unable to retrieve forms", "danger");
            }
        },
        searchWebform(keyword) {
            this.query = keyword;
            this.debounceSearchWebform(keyword, this);
        },
        debounceSearchWebform: debounce(async (search, self) => {
            self.getList(1);
        }, 350),
        async checkWebform(webform, action = "send") {
            // Retrieve the webform the get the webform_content
            try {
                const fetchDetails = await ClientWebformService.getWebformDetail(
                    webform.id
                );
                if (fetchDetails) {
                    // Update the webform object from the fetchDetails
                    Object.assign(webform, fetchDetails);

                    return this.checkCanSendWebform(
                        fetchDetails.webform_content,
                        action
                    );
                } else {
                    throw "Unable to retrieve the form details";
                }
            } catch (e) {
                this._message("Unable to retrieve the form details", "danger");
                this.getList();
                return false;
            }
        },
        async sendSMS(webform) {
            webform.isLoading = true;
            const isProceed = await this.checkWebform(webform);
            webform.isLoading = false;
            if (isProceed) {
                this.$refs.modalSMS.open(webform);
            }
        },
        async sendEmail(webform) {
            webform.isLoading = true;
            const isProceed = await this.checkWebform(webform);
            webform.isLoading = false;
            if (isProceed) {
                this.$refs.modalEmail.open(webform);
            }
        },
        deleteWebform(webform) {
            this.$refs.modalDeleteWebform.open(webform);
        },
        async printWebform(webform) {
            webform.isLoading = true;
            const isProceed = await this.checkWebform(webform, "print");
            if (isProceed) {
                await this.printWebformPDF(webform);
            }
            webform.isLoading = false;
        },
        onSuccess() {
            if (this.isSoap) {
                this.$emit(
                    "onSuccess",
                    "tabDocuments",
                    DOCUMENTS.VIEWS.WEBFORMS,
                    false
                );
            } else {
                this.$emit("getTabCounts");
            }
            this.getList();
        }
    }
};
</script>
